module.exports = __webpack_public_path__ + "466fbcdd2e2eda2d26894c9dbcfcbfd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/large_diamond_background.png
// module id = 857
// module chunks = 0